export const SIZE_GUIDE_POPUP_ID = 'SizeGuidePopup';
